import { render, staticRenderFns } from "./scratchers.vue?vue&type=template&id=0a5b0cec&scoped=true"
import script from "./scratchers.vue?vue&type=script&lang=js"
export * from "./scratchers.vue?vue&type=script&lang=js"
import style0 from "./scratchers.vue?vue&type=style&index=0&id=0a5b0cec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5b0cec",
  null
  
)

export default component.exports